/**
 * enterpriseWechatRobotOperationLog模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const enterpriseWechatRobotOperationLog = {
  //企业微信机器人操作日志
  listOperationLogs(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/enterpriseWechatRobotOperationLog/listOperationLogs`,param);
  }
}

export default enterpriseWechatRobotOperationLog;



// WEBPACK FOOTER //
// ./src/api/enterpriseWechatRobotOperationLog.js